import { UserInterface } from '@e3labs/isa-data-dictionary';
import { AxiosResponse } from 'axios';
import api from '~/services/api';

import { ClientVisitFeedbackResponseInterface, ClientVisitInterface } from './client-visit-interface';

class ClientVisitService {
  getAllClientVisit(
    { skip = 0, limit = 20, ...rest },
    opts?: any
  ): Promise<AxiosResponse<ClientVisitInterface[] | null>> {
    return api.get('/vendor-client-visit', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getAllClientVisitCount({ ...rest }, opts?: any): Promise<AxiosResponse<ClientVisitInterface[] | null>> {
    return api.get('/vendor-client-visit?isCount=true', {
      params: {
        ...rest
      },
      ...opts
    });
  }

  getClientVisitFeedbacks({
    id
  }: {
    id: string;
  }): Promise<AxiosResponse<ClientVisitFeedbackResponseInterface[] | null>> {
    return api.get('/client-visit-feedback', {
      params: {
        referenceVisitId: id
      }
    });
  }

  getSellers(opts?: any): Promise<AxiosResponse<UserInterface[] | null>> {
    return api.get('/user', {
      params: {},
      ...opts
    });
  }

  getClients(
    {
      skip = 0,
      limit = 10,
      userExternalCode,
      queryString
    }: {
      skip?: number;
      limit?: number;
      userExternalCode: string;
      queryString: string;
    },
    opts?: any
  ): Promise<AxiosResponse<any[] | null>> {
    return api.get('/client', {
      params: {
        skip,
        limit,
        fieldsToShow: 'externalCode,name',
        userExternalCode,
        queryString
      },
      ...opts
    });
  }

  getJustifications(opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/vendor-client-visit/preset-justification', {
      ...opts
    });
  }

  getCSV({ ...params }: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/vendor-client-visit/report', {
      params: {
        ...params
      }
    });
  }

  getXls({ ...params }): Promise<AxiosResponse<any[] | null>> {
    return api.get('/vendor-client-visit/report-xlsx', {
      params: {
        ...params
      },
      headers: {
        'Content-Disposition': 'attachment; filename=report.xlsx',
        'Content-Type': 'application/vnd.ms-excel'
      },
      responseType: 'arraybuffer'
    });
  }
}

export default new ClientVisitService();
